export function readExportPreferences(key, datasets, defaults) {
    const raw = localStorage.getItem(key);
    if (raw === null)
        return defaults;
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed))
        throw new Error('Saved export preferences are invalid. Reset the export preferences.');
    const result = [];
    for (const value of parsed) {
        if (typeof value !== 'object' || value === null || !('dataset' in value) ||
            typeof value.dataset !== 'string' || !('columns' in value) || !Array.isArray(value.columns)) {
            throw new Error('Saved export preferences are invalid.');
        }
        const dataset = datasets.find((item) => item.id === value.dataset);
        if (dataset === undefined)
            continue;
        const savedColumns = value.columns;
        const columns = savedColumns.filter((column) => typeof column === 'string' && dataset.columns.some((item) => item.id === column));
        if (columns.length > 0 && !result.some((item) => item.dataset === dataset.id)) {
            result.push({ dataset: dataset.id, columns: [...new Set(columns)] });
        }
    }
    return result.length > 0 ? result : defaults;
}
export function saveExportPreferences(key, selections) {
    localStorage.setItem(key, JSON.stringify(selections));
}
